import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'inss' })
export class InssPipe implements PipeTransform {

  transform(value: string): string {
    if ( null === value || undefined === value || value.length === 0 ) {
      return '-';
    } else {
      const result: string = value.replace(/\D/g, '');
      if (result.length === 11) {
        return result.substring(0, 2) + '.' +
          result.substring(2, 4) + '.' +
          result.substring(4, 6) + '-' +
          result.substring(6, 9) + '.' +
          result.substring(9, 11);
      }
      return value;
    }
  }
}
